import React, { ReactElement } from "react";

import { ButtonInner, StyledButton, SvgContainer } from "./components";

export type Props = {
  readonly onClick?: () => void;
  readonly children?: string;
  readonly Icon?: React.ComponentType | null | undefined;
  readonly className?: string;
};

// eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
const Button = ({
  children = "",
  onClick,
  Icon,
  className,
}: Props): ReactElement => (
  <StyledButton onClick={onClick} className={className}>
    <ButtonInner>
      {!!Icon && (
        <SvgContainer>
          <Icon />
        </SvgContainer>
      )}
      {children}
    </ButtonInner>
  </StyledButton>
);
export default Button;
